import {
  CUSTOM_ELEMENTS_SCHEMA,
  NgModule,
  NO_ERRORS_SCHEMA,
} from "@angular/core";
import { CommonModule } from "@angular/common";
import { SharedModule } from "@app/modules/shared/shared.module";
import { ListboxModule } from "primeng/listbox";
import { ShippingAddressListComponent } from "@dashboard/modules/finance-management/shipping-address/components/shipping-address-list/shipping-address-list.component";
import { ShippingAddressFormComponent } from "@dashboard/modules/finance-management/shipping-address/components/shipping-address-form/shipping-address-form.component";
import { CurrentAccountListComponent } from "@dashboard/modules/finance-management/current-account/components/current-account-list/current-account-list.component";
import { CurrentAccountFormComponent } from "@dashboard/modules/finance-management/current-account/components/current-account-form/current-account-form.component";
import { CurrentAccountDetailFilterComponent } from "@dashboard/modules/finance-management/current-account/components/current-account-detail-filter/current-account-detail-filter.component";
import { TabsModule } from "ngx-bootstrap/tabs";
import { SidebarModule } from "primeng/sidebar";
@NgModule({
  imports: [
    CommonModule,
    ListboxModule,
    SidebarModule,
    TabsModule,
    SharedModule.forRoot(),
  ],
  declarations: [
    CurrentAccountListComponent,
    CurrentAccountFormComponent,
    CurrentAccountDetailFilterComponent,
    ShippingAddressListComponent,
    ShippingAddressFormComponent,
  ],
  exports: [
    CurrentAccountListComponent,
    CurrentAccountFormComponent,
    ShippingAddressListComponent,
    ShippingAddressFormComponent,
  ],
  schemas: [NO_ERRORS_SCHEMA, CUSTOM_ELEMENTS_SCHEMA],
})
export class FinanceManagementModule {}
